import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../Dropdown';

/**
 * ActionDropdown - A reusable dropdown for action menus
 * 
 * Now using pure React Dropdown component instead of Bootstrap!
 */
const ActionDropdown = ({ actions, iconClass = 'icon-svg-dots-vertical', dropdownClass = '', menuClass = '' }) => {
    return (
        <Dropdown
            trigger={<span className={iconClass}></span>}
            align="right"
            className={dropdownClass}
            menuClassName={menuClass}
        >
            {actions.map((action) => (
                <Dropdown.Item
                    key={action.id}
                    href={action.href}
                    onClick={action.onClick}
                    icon={action.icon}
                    className={action.class}
                    dataAttributes={action.data}
                >
                    {action.text}
                </Dropdown.Item>
            ))}
        </Dropdown>
    );
};

ActionDropdown.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            href: PropTypes.string,
            class: PropTypes.string,
            text: PropTypes.string.isRequired,
            icon: PropTypes.string,
            target: PropTypes.string,
            data: PropTypes.array,
        })
    ).isRequired,
    iconClass: PropTypes.string,
    dropdownClass: PropTypes.string,
    menuClass: PropTypes.string,
};

export default ActionDropdown;
